import { useEffect, useState } from "react";
import Form from "../../../Components/Form";
import StaticDropdown from "../../../Components/Dropdown/StaticDropdown";
import TextInput from "../../../Components/TextInput";
import Button from "../../../Components/Button";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  IStepOptionDropdownItem,
  StepInstrumentType,
  StepOptionOrderType,
  StepOrderSide,
} from "../../../Interfaces/stepInterfaces";
import { toast } from "react-toastify";
import SahraConnections from "../../Sahra/SahraConnections";
import Modal from "../../../Components/Modal/Modal";
import UsersDropdown from "../../../Components/Dropdown/Users/UsersDropdown";
import { getStepInstruments } from "../../../Requests/stepRequests";
import {
  onDeltaHedgeOrderFormValuesChange,
  setDeltaHedgeOrderFormValues,
  setDeltaHedgeOrderTableFlag,
} from "../../../Features/DeltaHedgeOrder/deltaHedgeOrderSlice";
import { addDeltaHedgeOrder } from "../../../Requests/deltaHedgeOrder";
import { IDeltaHedgeOrderFormValues } from "../../../Interfaces/deltaHedgeOrder";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import { deltaHedgeOrderTypesDropdownOptions } from "../DeltaHedgeOrder";
import { DropdownItem } from "../../../Interfaces/dropdownInterfaces";
import DynamicDropdown from "../../../Components/Dropdown/DynamicDropdown";
import OrderPreviewTable, { DeltaHedgePreviewLookups, isDeltaHedgePreviewRowSendable } from "../OrderPreviewTable";
import InsWithTypeDropdown from "../../../Components/Dropdown/InsWithTypeDropdown";
import { User } from "../../../Interfaces/connections";

enum ModalMode {
  SahraOrderTable,
  OrderPreview,
}

export const orderSideOptions: DropdownItem[] = [
  { id: StepOrderSide.Buy, name: "خرید" },
  { id: StepOrderSide.Sell, name: "فروش" },
];

const SingleOrder = () => {
  const formValues = useAppSelector(
    (store) => store.deltaHedgeOrder.addOrderFormValues
  );

  const dispatch = useAppDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState<ModalMode>(
    ModalMode.SahraOrderTable
  );

  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState<{
    values: IDeltaHedgeOrderFormValues;
    lookups: DeltaHedgePreviewLookups;
  } | null>(null);
  const previewValues = preview?.values;
  const [accounts, setAccounts] = useState<User[] | null>(null);

  const [instrumentOptions, setInstrumentOptions] = useState<
    IStepOptionDropdownItem[] | null
  >(null);

  useEffect(() => {
    getStepInstruments()
      .then((resp) => {
        setInstrumentOptions(resp);
      })
      .catch(packetErrorHandler);
  }, []);

  const modalCloseHandler = () => {
    setIsModalOpen(false);
  };

  const changeHandler = (
    name: string,
    value: any,
    name2?: string,
    value2?: any
  ) => {
    dispatch(onDeltaHedgeOrderFormValuesChange({ name, value, name2, value2 }));
  };

  const addStepShekarOrderClickHandler = () => {
    if (loading || !previewValues || !isDeltaHedgePreviewRowSendable(previewValues)) return;
    setLoading(true);
    addDeltaHedgeOrder(previewValues)
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          setIsModalOpen(false);
          dispatch(setDeltaHedgeOrderTableFlag(true));
          dispatch(
            setDeltaHedgeOrderFormValues({
              instrumentId1: previewValues.instrumentId1,
              instrumentId2: previewValues.instrumentId2,
              optionOrderType1: previewValues.optionOrderType1,
              optionOrderType2: previewValues.optionOrderType2,
              orderSide1: previewValues.orderSide1,
              orderSide2: previewValues.orderSide2,
            } as IDeltaHedgeOrderFormValues)
          );
        }
      })
      .catch(packetErrorHandler)
      .finally(() => {
        setLoading(false);
      });
  };

  const getSahraUserTable = () => {
    return (
      <div className="flex flex-col justify-start items-center gap-3">
        <SahraConnections
          initialSearchParam={{
            userIds: [previewValues?.accountId] as number[],
          }}
        />

        {getBtn(addStepShekarOrderClickHandler, loading || !isDeltaHedgePreviewRowSendable(previewValues))}
      </div>
    );
  };

  const getOrderPreviewTable = () => {
    if (!previewValues) return <></>;

    return (
      <div className="flex flex-col justify-start items-center gap-10">
        <OrderPreviewTable values={[previewValues]} lookups={preview?.lookups} />
        {getBtn(() => setModalMode(ModalMode.SahraOrderTable), !isDeltaHedgePreviewRowSendable(previewValues))}
      </div>
    );
  };

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.SahraOrderTable:
        return getSahraUserTable();

      case ModalMode.OrderPreview:
        return getOrderPreviewTable();
    }
  };

  const getBtn = (onClick: () => void, disabled?: boolean) => (
    <Button
      text="ارسال"
      onClick={onClick}
      variant="contained"
      disabled={disabled}
    />
  );

  const optionsOrderTypes = [
    {
      id: StepOptionOrderType.Offset,
      name: "Offset",
    },
    {
      id: StepOptionOrderType.Open,
      name: "Open",
    },
  ];

  const checkBtnDisabled = () => {
    if (
      !formValues?.accountId ||
      !accounts ||
      !instrumentOptions ||
      !formValues?.instrumentId1 ||
      !formValues?.instrumentId2 ||
      !formValues?.orderSide1 ||
      !formValues?.orderSide2 ||
      !formValues?.deltaHedgeOrderType ||
      !formValues?.baseVolume ||
      !formValues?.baseVolumeSide ||
      !formValues?.marginInPercent ||
      !formValues?.blockSize
    )
      return true;

    return false;
  };

  const baseVolumeSideOptions: DropdownItem[] = [
    { id: 1, name: "نماد اول" },
    { id: 2, name: "نماد دوم" },
  ];

  return (
    <Form className="!w-80 gap-3 p-2 px-2">
      {isModalOpen ? (
        <Modal modalBoxClassName="!min-w-0 w-[1320px]" onClose={modalCloseHandler} UI={getModalUI()} />
      ) : (
        <></>
      )}

      <UsersDropdown
        label="نام اکانت"
        name="accountId"
        value={formValues?.accountId}
        onChange={changeHandler}
        onDataFetch={setAccounts}
        extraLabel
      />

      <StaticDropdown
        dropdown={{
          name: "deltaHedgeOrderType",
          placeholder: "فرایند",
          extraLabel: true,
        }}
        onChange={changeHandler}
        options={deltaHedgeOrderTypesDropdownOptions}
        value={formValues?.deltaHedgeOrderType}
      />

      <div className="flex flex-row justify-start items-center gap-1 w-full">
        <StaticDropdown
          dropdown={{
            name: "orderSide1",
            placeholder: "جهت 1",
            extraLabel: true,
          }}
          onChange={changeHandler}
          options={orderSideOptions}
          value={formValues?.orderSide1}
        />
        <StaticDropdown
          dropdown={{
            name: "orderSide2",
            placeholder: "جهت 2",
            extraLabel: true,
          }}
          onChange={changeHandler}
          options={orderSideOptions}
          value={formValues?.orderSide2}
        />
      </div>

      <InsWithTypeDropdown
        insValue={formValues?.instrumentId1}
        onInsChange={(name: string, value: any) => changeHandler(name, value)}
        onTypeChange={changeHandler}
        insInfo={{
          name: "instrumentId1",
          placeholder: `نماد اول`,
        }}
        typeInfo={{
          name: "optionOrderType1",
          placeholder: `نوع معامله اختیار اول`,
        }}
        typeValue={formValues?.optionOrderType1}
        instrumentOptions={instrumentOptions || []}
      />

      <InsWithTypeDropdown
        insValue={formValues?.instrumentId2}
        onInsChange={(name: string, value: any) => changeHandler(name, value)}
        onTypeChange={changeHandler}
        insInfo={{
          name: "instrumentId2",
          placeholder: `نماد دوم`,
        }}
        typeInfo={{
          name: "optionOrderType2",
          placeholder: `نوع معامله اختیار دوم`,
        }}
        typeValue={formValues?.optionOrderType2}
        instrumentOptions={instrumentOptions || []}
      />

      <div className="flex flex-row justify-start items-center gap-1 w-full">
        <StaticDropdown
          dropdown={{
            name: "baseVolumeSide",
            placeholder: "طرف مرجع حجم",
            extraLabel: true,
          }}
          onChange={changeHandler}
          options={baseVolumeSideOptions}
          value={formValues?.baseVolumeSide}
        />
        <TextInput
          label="حجم مرجع"
          value={formValues?.baseVolume?.toString()}
          name="baseVolume"
          onChange={changeHandler}
          extraLabel
        />
      </div>
      <TextInput
        label="بازده قفل هدف"
        value={formValues?.lockProfitTarget?.toString()}
        name="lockProfitTarget"
        onChange={changeHandler}
        extraLabel
      />

      <TextInput
        label="حجم هر بلوک به صورت درصدی"
        name="blockSize"
        onChange={changeHandler}
        value={formValues?.blockSize?.toString()}
        extraLabel
      />
      <TextInput
        label="مارجین به صورت درصدی"
        name="marginInPercent"
        onChange={changeHandler}
        value={formValues?.marginInPercent?.toString()}
        kind="percent"
        extraLabel
      />

      {getBtn(() => {
        if (!formValues || !accounts || !instrumentOptions) return;
        setPreview({
          values: { ...formValues },
          lookups: { accounts, instruments: instrumentOptions },
        });
        setIsModalOpen(true);
        setModalMode(ModalMode.OrderPreview);
      }, checkBtnDisabled())}
    </Form>
  );
};

export default SingleOrder;
